var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 1C11 0.585786 10.6642 0.25 10.25 0.25C9.83579 0.25 9.5 0.585786 9.5 1C9.5 4.09482 8.83276 6.10342 7.57233 7.35364C6.31066 8.6051 4.30042 9.25 1.25 9.25C0.835786 9.25 0.5 9.58579 0.5 10C0.5 10.0876 0.515033 10.1718 0.542662 10.25C0.52846 10.25 0.514239 10.25 0.5 10.25C0.514249 10.25 0.528479 10.25 0.542691 10.25C0.645662 10.5413 0.923461 10.75 1.25 10.75C4.29544 10.75 6.3071 11.4117 7.5706 12.6731C7.71409 12.8164 7.84987 12.9693 7.97785 13.1324C9.0128 14.5774 9.5 16.595 9.5 19.25C9.5 19.1794 9.50034 19.1093 9.50103 19.0396C9.52161 19.4354 9.84907 19.75 10.25 19.75C10.6642 19.75 11 19.4142 11 19C11 15.9444 11.662 13.9335 12.9227 12.6727C14.1835 11.412 16.1944 10.75 19.25 10.75C19.6642 10.75 20 10.4142 20 10C20 9.58579 19.6642 9.25 19.25 9.25C16.1895 9.25 14.1799 8.60483 12.921 7.35407C11.663 6.10431 11 4.09606 11 1ZM11.162 7.59451C10.7918 7.0799 10.4891 6.50574 10.2483 5.87316C10.2413 5.89152 10.2342 5.90983 10.2271 5.92809C10.4734 6.55633 10.7841 7.11065 11.162 7.59451Z",
    fill: "#C06674"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.1e0dbad0b63e2c11ad4890c797604d2e.svg";
export { ForwardRef as ReactComponent };